export const TERMO = () => `/termo`;
